import * as React from 'react';

/**
 * Provide a unique id in React memo
 */
var useUniqueId = function useUniqueId() {
  return React.useMemo(function () {
    return window.Math.random().toString(16).slice(2);
  }, []);
};

export { useUniqueId as default };
//# sourceMappingURL=useUniqueId.js.map
